
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Minus } from 'lucide-react';
import { RepairLineItem } from '@/types/quick-compare';
import { ItemCard } from './ItemCard';

interface RemovedItemsTabProps {
  removedItems: (RepairLineItem & { section?: string })[];
  count: number;
}

export const RemovedItemsTab: React.FC<RemovedItemsTabProps> = ({ removedItems, count }) => {
  return (
    <Card className="pt-4">
      <CardHeader>
        <CardTitle className="flex items-center">
          <Minus className="h-4 w-4 mr-2 text-red-600" /> 
          Removed Items ({count})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {removedItems.length > 0 ? (
          <div className="space-y-4">
            {removedItems.map((item, index) => (
              <ItemCard
                key={index}
                item={item}
                variant="removed"
              />
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground">No items were removed.</p>
        )}
      </CardContent>
    </Card>
  );
};
